module.exports = __webpack_public_path__ + "static/media/white-background.4458fcf1.svg";